<template>
<!-- 插件 -->
<el-dialog title="新增/编辑" :visible.sync="fromVisible" :before-close="handleClose" @opened="openFrom()">
    <el-form :model="formData" :rules="rules" ref="ruleForm">
      <el-form-item label="用户账号" :label-width="formLabelWidth" prop="user_account" style="margin-bottom: 17px">
        <el-input v-model="formData.user_account" autocomplete="off" :disabled="formData.id ? true : false" placeholder="请输入用户账号"  @blur="blurGetUser"></el-input>
      </el-form-item>
    </el-form>
    <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="用户名称" :label-width="formLabelWidth" prop="user_name" style="margin-bottom: 17px">
          <el-input v-model="formData.user_name" :disabled="true" autocomplete="off" ></el-input>
        </el-form-item>
    </el-form>
    <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="用户身份" :label-width="formLabelWidth" prop="user_ident_text" style="margin-bottom: 17px">
          <el-input v-model="formData.user_ident_text" :disabled="true" autocomplete="off" ></el-input>
        </el-form-item>
    </el-form>
    <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="睿收钱权限" :label-width="formLabelWidth" prop="p_auth" style="margin-bottom: 17px">
            <el-radio v-model="formData.p_auth" label="1">启用</el-radio>
            <el-radio v-model="formData.p_auth" label="2">停用</el-radio>
        </el-form-item>
    </el-form>
    <el-form :model="formData" :rules="rules" ref="ruleForm">
        <el-form-item label="睿收钱范围" :label-width="formLabelWidth" prop="auth_range" style="margin-bottom: 17px">
            <el-radio v-model="formData.auth_range" label="1">自身</el-radio>
            <el-radio v-model="formData.auth_range" label="2">全链</el-radio>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose()">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </div>
</el-dialog>
</template>
<script>
    export default {
        name:"fromAuth",
        props:{
            fromVisible:Boolean,   
            auth_id:Number,   
        },
        data(){
            return {
                formData:{
                    user_account:'', //用户账号
                    user_name:'',//用户名称 
                    user_ident_text:'', //用户身份 
                    user_id:'', //用户ID
                    p_auth:'', //用户权限 
                    auth_range:'', //用户权限范围 
                    id:'', //主键ID 
                },//数据
                formLabelWidth: '120px', //表单宽度 
                rules: { //验证规则 
                    user_account: [
                        {required: true, message: '请输入用户账号', trigger: 'blur'}
                    ],
                    user_name: [
                        {required: true, message: '用户信息获取失败,请从新输入账号', trigger: 'blur'}
                    ],
                    p_auth:[
                        {required: true, message: '请选择睿收钱权限', trigger: 'blur'}
                    ],
                    auth_range:[
                        {required: true, message: '请选择睿收钱权限范围', trigger: 'blur'}
                    ]
                },
                lock:true,
            }
        },
        mounted() {
            if(this.auth_id){
                this.findAuth(this.auth_id);
            }
           
        },
        methods: {
            //关闭弹窗 
            handleClose() {
                this.$emit('getData');
                this.$emit('handleFromVisible',false);
            },
             // 添加表单校验
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                      if(!this.formData.user_name){
                        this.$message.error('获取用户信息失败 请从新添加');
                        return false;
                      }
                    // 添加确定
                        this.$api.post('/api/Productauth/saveAuth', this.formData, res => {
                            if (res.status == 200) {
                            this.$message({
                                type: 'success',
                                message: '操作成功',
                                duration: 1000,
                            });
                            this.handleClose();
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            //查询角色信息 
            findAuth(id){
                this.$api.post("/api/Productauth/findProductAuth", {id}, res => {
                    if(res.status == 200){
                        const data = res.data;
                        this.formData.user_name =  data.user_name;
                        this.formData.user_ident_text =  data.user_ident_text;
                        this.formData.auth_range =  data.auth_range.value.toString();
                        this.formData.p_auth =  data.p_auth.value.toString();
                        this.formData.id =  data.id;
                        this.formData.user_id =  data.user_id;
                        this.formData.user_account =  data.user_account;                        
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //获取用户信息 
            getUserByAccount(){
                if(!this.formData.user_account){
                    this.$message.error('请输入账号');
                    return false;
                }
                this.$api.post("/api/ProductAuth/getUserByAccount", {user_account:this.formData.user_account}, res => {
                    if(res.status == 200){
                        const data = res.data;  
                        if(data.length == 0){
                            this.$message.error('未查询到用户信息'); 
                        }else{
                            this.$set(this.formData,'user_ident_text',data.user_ident_text);
                            this.$set(this.formData,'user_name',data.user_name);
                            // this.$set(this.formData,'user_id',data.user_id);
                            this.formData.user_id = data.id;
                        }  
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            //清除数据 
            clearData(){
                this.formData = [];
            },
            blurGetUser(){
                this.getUserByAccount();
            }
        }
    }
</script>
<style scoped>
    .menu_tree{
        margin-top:10px;
    }
</style>
